/* bysundays — ready-made product page.

   Option buttons are real buttons over a real form. With JS off the noscript
   variant select still posts a valid id, so the page always sells.

   Every price shown comes from the variant JSON Shopify rendered into the page;
   nothing here computes a price from parts. */

(function () {
  'use strict';

  var CFG = window.bysundays || {};

  function formatMoney(cents, format) {
    if (typeof cents !== 'number') cents = parseInt(cents, 10) || 0;
    var fmt = format || CFG.moneyFormat || '${{amount}}';

    function group(number, decimals, thousands, decimal) {
      var value = (number / 100).toFixed(decimals);
      var parts = value.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }

    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_m, name) {
      switch (name) {
        case 'amount': return group(cents, 2, ',', '.');
        case 'amount_no_decimals': return group(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return group(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(cents, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return group(cents, 0, ' ', '.');
        case 'amount_with_space_separator': return group(cents, 2, ' ', ',');
        default: return '';
      }
    });
  }

  function ProductPage(root) {
    this.root = root;
    this.form = root.querySelector('[data-product-form]');

    var variantNode = document.querySelector('[data-product-variants]');
    var stringNode = document.querySelector('[data-product-strings]');
    this.variants = variantNode ? JSON.parse(variantNode.textContent) : [];
    this.strings = stringNode ? JSON.parse(stringNode.textContent) : {};

    this.groups = Array.prototype.slice.call(root.querySelectorAll('[data-option-group]'));
    this.selection = this.readSelection();

    this.bind();
    this.render();
  }

  ProductPage.prototype.readSelection = function () {
    var selection = [];
    this.groups.forEach(function (group) {
      var position = parseInt(group.getAttribute('data-option-group'), 10);
      var pressed = group.querySelector('[aria-pressed="true"]');
      selection[position - 1] = pressed ? pressed.getAttribute('data-option-value') : null;
    });
    return selection;
  };

  ProductPage.prototype.variantFor = function (selection) {
    return (
      this.variants.filter(function (variant) {
        return selection.every(function (value, index) {
          return value == null || variant.options[index] === value;
        });
      })[0] || null
    );
  };

  ProductPage.prototype.bind = function () {
    var self = this;

    this.root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-option-value]');
      if (!button || !self.root.contains(button)) return;
      event.preventDefault();
      var position = parseInt(button.getAttribute('data-option-position'), 10);
      self.selection[position - 1] = button.getAttribute('data-option-value');
      self.render();
    });

    /* Gallery */
    this.root.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-gallery-thumb]');
      if (!thumb) return;
      self.showMedia(thumb.getAttribute('data-gallery-thumb'));
    });
  };

  ProductPage.prototype.showMedia = function (mediaId) {
    if (!mediaId || mediaId === '0') return;
    this.root.querySelectorAll('[data-gallery-slide]').forEach(function (slide) {
      slide.hidden = slide.getAttribute('data-gallery-slide') !== String(mediaId);
    });
    this.root.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.setAttribute(
        'aria-pressed',
        String(thumb.getAttribute('data-gallery-thumb') === String(mediaId))
      );
    });
  };

  ProductPage.prototype.render = function () {
    var self = this;
    var variant = this.variantFor(this.selection);

    /* Pressed state, plus the price and availability each option value leads to
       when the rest of the selection is held where it is. */
    this.groups.forEach(function (group) {
      var position = parseInt(group.getAttribute('data-option-group'), 10);

      group.querySelectorAll('[data-option-value]').forEach(function (button) {
        var value = button.getAttribute('data-option-value');
        button.setAttribute('aria-pressed', String(self.selection[position - 1] === value));

        var probe = self.selection.slice();
        probe[position - 1] = value;
        var match = self.variantFor(probe);

        button.setAttribute('data-unavailable', String(!match || !match.available));

        var priceEl = button.querySelector('[data-option-price]');
        if (priceEl) {
          if (!match) priceEl.textContent = self.strings.unavailablePairing || '';
          else if (!match.available) priceEl.textContent = self.strings.soldOut || '';
          else priceEl.textContent = formatMoney(match.price);
        }

        var noteEl = button.querySelector('[data-option-note]');
        if (noteEl) {
          noteEl.textContent =
            match && match.available ? self.strings.sizeNote || '' : self.strings.soldOut || '';
        }
      });
    });

    var priceEl = this.root.querySelector('[data-price]');
    var compareEl = this.root.querySelector('[data-compare]');
    var idInput = this.root.querySelector('[data-variant-id]');
    var addButton = this.root.querySelector('[data-add-button]');
    var addLabel = this.root.querySelector('[data-add-label]');

    if (variant) {
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare > variant.price) {
          compareEl.textContent = formatMoney(variant.compare);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (idInput) idInput.value = variant.id;
      if (addButton) addButton.disabled = !variant.available;
      if (addLabel) {
        addLabel.textContent = variant.available
          ? (this.strings.addToCart || 'Add to basket') + ' — ' + formatMoney(variant.price)
          : this.strings.soldOut || 'Sold out';
      }
      if (variant.mediaId) this.showMedia(variant.mediaId);

      // Keep the URL shareable and the back button honest.
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    } else {
      if (addButton) addButton.disabled = true;
      if (addLabel) addLabel.textContent = this.strings.unavailablePairing || 'Unavailable';
    }
  };

  function boot() {
    document.querySelectorAll('[data-product-root]').forEach(function (root) {
      if (root.dataset.booted) return;
      root.dataset.booted = '1';
      try {
        new ProductPage(root);
      } catch (err) {
        if (window.console) console.error('product', err);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
